module.exports = __webpack_public_path__ + "static-v-shop/1770130202702/img/ic-tips.6f923265.png";